import moment from 'moment';
import React, { useState } from 'react';
import toast from 'react-hot-toast';
import { QueryClient, QueryClientProvider } from 'react-query';
import Cookies from 'universal-cookie';

import IconClose from '@components/Images/Rebranding/IconClose';
import LogoTIProWithIconTI from '@components/Images/Rebranding/LogoTIProWithIconTI';
import LogoTIWithIconTI from '@components/Images/Rebranding/LogoTIWithIconTI';
import StepProfile from '@components/OnboardingModal/StepProfile';
import Modal from '@mui/material/Modal';

const queryClient = new QueryClient();

interface UpdateProfileModalProps {
  currentUserId: number;
  isProSubscriber: boolean;
}

const cookies = new Cookies();
const PROFILE_MODAL = 'update-profile-modal';

const UpdateProfileModal = ({ currentUserId, isProSubscriber }: UpdateProfileModalProps) => {
  const seenModaLast14Days = cookies.get(PROFILE_MODAL);
  const [isOpen, setIsOpen] = useState(!seenModaLast14Days);

  const handleSubmit = () => {
    toast.success('Profile updated successfully');
    setIsOpen(false);
  };

  const handleClose = () => {
    cookies.set(PROFILE_MODAL, true, {
      expires: moment().add(14, 'days').toDate(),
    });
    setIsOpen(false);
  };

  return (
    <QueryClientProvider client={queryClient}>
      <Modal
        className="OnboardingModal"
        open={isOpen}
        onClose={handleClose}
        disableAutoFocus={true}
      >
        <div data-testid="update-profile-modal" className="onboarding">
          <div className="onboarding-header border-none">
            <IconClose
              className="absolute right-10 top-10 h-20 cursor-pointer"
              onClick={handleClose}
            />
            {isProSubscriber ? (
              <LogoTIProWithIconTI className="h-[35px] w-auto" />
            ) : (
              <LogoTIWithIconTI className="h-[35px] w-auto" />
            )}
          </div>

          <p className="m-0 hidden bg-primary-magenta py-16 text-center font-suisse-neue text-overline-md text-white sm:block">
            Before continuing please update your profile, we’ll provide articles closer to your
            interests.
          </p>

          <StepProfile
            currentUserId={currentUserId}
            heading="Update Your Member Profile"
            nextStep={handleSubmit}
          />
        </div>
      </Modal>
    </QueryClientProvider>
  );
};

export default UpdateProfileModal;
